<template>
  <div class="header">
    <div class="wrap">
      <div class="wrap-head">
        <div class="head-left">
          <div class="head-top">
            <img class="logo"
                 @click="goHome"
                 :src="logo"
                 alt />
            <div class="head-rights"
                 :style="loginState ? 'width: 440px;' : 'width: 404px;'">
              <div class="user-info">
                <template v-if="!loginState">
                  <ul class="login">
                    <li :class="{'select':isSelct===1}"
                        @click="goLogin(1)">立即登录
                    </li>
                    <li :class="{'select':isSelct===2}"
                        @click="goLogin(2)">注册
                    </li>
                  </ul>
                </template>
                <template v-else>
                  <ul class="login"
                      style="border-radius:0;">
                    <li>
                      <template v-if="loginState">
                        <Dropdown trigger="click">
                          <a href="javascript:void(0)"
                             style="color:#fff;">
                            {{this.username}}
                            <Icon type="ios-arrow-down"></Icon>
                          </a>
                          <DropdownMenu slot="list">
                            <DropdownItem>
                              <router-link to="/personal">个人信息</router-link>
                            </DropdownItem>
                            <DropdownItem>
                              <router-link @click.native='getUnread' to="/myfile">我的资料</router-link>
                            </DropdownItem>
                            <DropdownItem>
                              <a href="javascript:;"
                                 @click="logout">退出</a>
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </template>
                      <template v-else>
                        <a href="javascript:;">游客</a>
                      </template>
                      <!-- <router-link to="/"><img class="link-icon" :src="person" alt=""></router-link> -->
                    </li>
                  </ul>
                  <router-link class="letter"
                               to="/mail">站内信
                    <span>{{unread}}</span>
                  </router-link>
                </template>
              </div>
              <div class="bm-info">
                <i>{{phone}}</i>
                <!-- <p>{{time}}</p> -->
              </div>
            </div>
          </div>
          <div class="head-bottom">
            <div style="width:84%">
              <template v-if="navFlag">
                <ul class="nav">
                  <li v-for="(item,index) in overseasNavList"
                      :key="index">
                    <a :class="{'hover-style':isHover===index}"
                       v-if="!item.childList"
                       @click="setHomeNavList(index,item)">{{item.name}}</a>
                    <Dropdown v-else>
                      <a :class="{'hover-style':isHover===index}"
                         @click="setHomeNavList(index,item)">{{item.name}}</a>
                      <DropdownMenu slot="list">
                        <DropdownItem v-for="(country,index) in item.childList"
                                      :key="index">
                          <router-link :to="country.path">{{country.name}}</router-link>
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </li>
                </ul>
              </template>
              <template v-else>
                <ul class="nav home-nav">
                  <li v-for="(item,index) in homeNavList"
                      :key="index">
                    <a :class="{'hover-style':isHover===index}"
                       v-if="!item.childList"
                       @click="setHomeNavList(index,item)">{{item.name}}</a>
                    <Dropdown v-else>
                      <a :class="{'hover-style':isHover===index}"
                         @click="setHomeNavList(index,item)">{{item.name}}</a>
                      <DropdownMenu slot="list">
                        <DropdownItem v-for="(country,index) in item.childList"
                                      :key="index">
                          <h2 v-if="country.title">{{country.title}}</h2>
                          <router-link target="_blank"
                                       :to="country.path">{{country.name}}</router-link>
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </li>
                </ul>
              </template>
            </div>
            <router-link class="hypopel"
                         to="/vipService">会员通道</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import logo from "@/assets/images/logo.jpg";
import person from "@/assets/images/person.png";
import { mapState } from "vuex";
import * as apis from "@/api/other";
// import * as api from '@/api/login';
import { homeNavList, overseasNavList } from "@/config/headNav.js"
import { getLocalStorage, setLocalStorage } from '@/utils/tools.js'
export default {
  data () {
    return {
      username: "",
      logo: logo,
      person: person,
      flag: false,
      navFlag: false,
      // flag: false,
      //loging: false,
      phone: "",
      time: "",
      isSelct: 1, // 登录1，注册2
      homeNavList: [],
      overseasNavList: [],
      isHover: 0,
      unread: 0,
      isToken: false
    };
  },
  created () {
    this.homeNavList = homeNavList
    this.overseasNavList = overseasNavList
    this.isSelct = Number(this.$route.params.type) ? Number(this.$route.params.type) : 1
    let path = this.$route.path
    if (path == '/') {
      this.isHover = ''
    }

    for (let i = 0; i < this.homeNavList.length; i++) {
      if (path == this.homeNavList[i].path) {
        if (path == '/internationalIndex') {
          this.isHover = 0
          break
        }
        this.isHover = i
        break
      }
    }
    for (let j = 0; j < this.overseasNavList.length; j++) {
      if (path == this.overseasNavList[j].path) {
        if (path == '/internationalIndex') {
          this.isHover = 0
          break
        } else {
          this.isHover = j
          break
        }
      }
    }
    if (path.includes('hospitalList/fwlx')) {
      this.isHover = 1
    } else if (path.includes('hospitalList/jmtj')) {
      this.isHover = 2
    } else if (path.includes('rescue')) {
      this.isHover = 2
    } else if (path.includes('doctorInfo')) {
      this.isHover = 7
    } else if (path.includes('successCase')) {
      this.isHover = 8
    }
  },
  async mounted () {
    let token = getLocalStorage('token');
    if (token) {
      this.isToken = true

    } else {
      this.isToken = false
    }
    if (localStorage.getItem('username') && localStorage.getItem('username') !== 'null' && localStorage.getItem('username') !== 'undefined') {
      this.username = localStorage.getItem('username')
    } else {
      this.username = '用户'
    }
    this.flag = this.$route.path.indexOf("international" > -1) ? true : false;
    this.getPhoneAndTime();
    if (this.isToken) {
      this.getUnread()
    }
  },
  computed: {
    ...mapState({
      mail: state => state.mail,
      loginState: 'loginState'
    })
  },
  watch: {
    username: {
      immediate: true,
      handler: function (newVal, oldVal) {
        if (newVal == "用户") {
          this.flag = false;
        } else {
          this.flag = true;
        }
      }
    },
    $route: {
      handler: function (newVal, oldVal) {
        let path = this.$route.path;
        for (let i = 0; i < this.homeNavList.length; i++) {
          if (path == this.homeNavList[i].path) {
            if (path == '/internationalIndex') {
              this.isHover = 0
              break
            }
            this.isHover = i
            break
          }
        }
        for (let j = 0; j < this.overseasNavList.length; j++) {
          if (path == this.overseasNavList[j].path) {
            if (path == '/internationalIndex') {
              this.isHover = 0
              break
            } else {
              this.isHover = j
              break
            }
          }
        }
        if (path.includes('rescue')) {
          this.isHover = 2
        } else if (path.includes('successCase')) {
          this.isHover = 8
        } else if (path.includes('myfile')) {
          this.isHover = 0
        }else if(path.includes('vipService')){
          this.isHover = -1
        } else if(path.includes('login')) {
          this.isHover = -1
        }
        this.username = localStorage.getItem("username") || "用户";

        if (
          path.indexOf("international") > -1 ||
          path.indexOf("successCase") > -1 ||
          path.indexOf("hospitalList") > -1 ||
          path.indexOf("hospitalInfo") > -1 ||
          path.indexOf("doctorList") > -1 ||
          path.indexOf("doctorInfo") > -1 ||
          path.indexOf("form") > -1 ||
          path.indexOf('agreements') > -1 ||
          path.indexOf('myfile') > -1 ||
          path.indexOf('mail') > -1 ||
          path.indexOf('internationalIndex') > -1 ||
          path.indexOf('pay') > -1 ||
          path.includes("login")
        ) {
          this.navFlag = true;
        } else {
          this.navFlag = false;
        }
        if (path.includes('login')) {
          setLocalStorage("loginState", false);
        }
      },
      immediate: true
    },
    mail (value, old) {
      this.getUnread()
    }
  },
  methods: {
    goHome () {
      this.$router.push('/home')
      this.isHover = 100
    },
    logout () {
      localStorage.setItem("username", "");
      localStorage.setItem("token", "");
      localStorage.removeItem("username");
      this.$router.push({
        name: 'login',
        params: {
          type: 1
        }
      })
      // this.loging = false;
      this.$store.commit("LOGIN_STATE", false);
      setLocalStorage("loginState", false);
      this.username = ''
    },
    goLogin (type) {
      this.isSelct = type
      this.$router.push({
        name: 'login',
        params: {
          type: type
        }
      })
    },
    async getPhoneAndTime () {
      try {
        let res = await apis.getPhoneAndTime({});
        if (res.code == 200) {
          this.phone = res.data.phone;
          this.time = res.data.text;
        }
      } catch (e) {
        console.log(e);
      }
    },
    // 获取站内信未读条数
    async getUnread () {
      if (localStorage.getItem('username') && localStorage.getItem('username') !== 'null') {
        this.username = localStorage.getItem('username')
      } else {
        this.username = '用户'
      }
      try {
        let res = await apis.getUnread({});
        if (res.code == 200) {
          this.unread = res.data.count
          // this.phone = res.data.phone;
          // this.time = res.data.text;
          setTimeout(() => {
            this.getUnread()
          }, 1000 * 60)
        }
      } catch (e) {
        console.log(e);
      }
    },
    setHomeNavList (index, item) {
      if (item.path == '/internationalIndex') {
        this.isHover = 0
      } else {
        this.isHover = index
      }
      this.$router.push({
        path: item.path
      })
    },
    goPage (path) {
      this.$router.push({
        path: path
      })
      return
    }
  }
};
</script>
<style lang="less" scoped>
.header {
  width: 100%;
  // height: 100px;
  background: #fff;
}
.wrap {
  width: 970px;
  margin: 0 auto;
  overflow: hidden;
}
.head-left {
  flex: 1;
}
.head-right {
  width: 218px;
  margin-left: 10px;
  p {
    font-size: 12px;
    color: #686868;
    line-height: 20px;
    text-align: center;
    margin: 8px 0;
    text-align: right;
  }
}
.logo {
  width: 126px;
  height: 46px;
  vertical-align: top;
  margin-top: 20px;
  display: inline-block;
  cursor: pointer;
}
.login {
  display: inline-block;
  float: right;
  margin-top: 30px;
  border-radius: 4px;
  height: 32px;
  overflow: hidden;
  /*border: 1px solid #ae1e10;*/

  > li {
    float: left;
    width: 80px;
    height: 32px;
    text-align: center;
    color: #ae1e10;
    line-height: 32px;
    text-align: center;
    cursor: pointer;
    border-radius: 4px;
    border: 1px solid #ae1e10;
    a {
      color: #ae1e10 !important;
    }
  }
  > .select {
    background: #ae1e10;
    color: #fff;
  }
}
.letter {
  position: relative;
  float: right;
  display: inline-block;
  width: 118px;
  height: 32px;
  background-color: #f6f6f6;
  background-image: url('../assets/images/home/icon-letter.png');
  background-repeat: no-repeat;
  background-position: 20px 9px;
  color: #333130;
  font-size: 14px;
  line-height: 32px;
  text-align: center;
  padding-left: 28px;
  margin-top: 30px;
  margin-right: 18px;
  span {
    position: absolute;
    display: block;
    top: 8px;
    right: 4px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    color: #fff;
    font-size: 10px;
    line-height: 16px;
    background: #ae1e10;
  }
}
.head-top {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  .head-rights {
    display: flex;
    justify-content: space-between;
    width: 404px;
    .user-info {
      display: flex;
      justify-content: space-between;
    }
    .bm-info {
      width: 200px;
      margin-top: 32px;
      i {
        float: right;
        width: 186px;
        display: block;
        font-size: 16px;
        color: #ae1e10;
        font-style: normal;
        position: relative;
        text-align: right;
        margin-bottom: 9px;
        &::before {
          content: '';
          width: 15px;
          height: 15px;
          background: url('../assets/images/home/phone-head.png') no-repeat left
            center;
          background-size: contain;
          position: absolute;
          left: -10px;
        }
      }
      p {
        float: right;
        text-align: right;
        color: #686868;
        font-size: 12px;
      }
    }
  }
}
.head-bottom {
  margin-bottom: 14px;
  display: flex;
  justify-content: space-between;
  .hypopel {
    display: inline-block;
    width: 97px;
    height: 30px;
    background: url('../assets/images/home/head-vip.jpg') no-repeat right;
    color: #fff;
    font-size: 14px;
    line-height: 30px;
    text-align: center;
    float: right;
    text-indent: -6px;
  }
}
.nav {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  li {
    a {
      color: #565656;
      font-size: 16px;
      line-height: 32px;
    }
  }
}
.link-icon {
  vertical-align: text-bottom;
  margin-right: 6px;
}
.nav li a.hover-style {
  color: #ae1e10;
}

.ivu-dropdown-menu {
  .ivu-dropdown-item {
    text-align: center;
    a {
      color: #000;
    }
    a.hover-style {
      &::before {
        bottom: -10px;
      }
    }
  }
}
.menu-link {
  display: block;
}
</style>
<style lang="less">
.home-nav {
  .ivu-dropdown-item {
    text-align: left !important;
    padding: 0;
    a {
      display: block;
      width: 100%;
      box-sizing: border-box;
      padding: 11px 30px;
      color: #333230;
    }
    h2 {
      padding: 11px 30px;
      font-size: 20px;
      color: #333230;
      margin-top: 42px;
      cursor: default;
    }
    h2:first-child {
      margin-top: 0px;
    }
  }

  .ivu-dropdown-item:hover {
    background: #fff !important;

    a:hover {
      background: #f3f3f3;
    }
  }
}
</style>
